import Lenis from '@theme/lenis';

/**
 * Initializes the Lenis smooth scrolling library.
 * This class handles the requestAnimationFrame loop and ensures it doesn't run
 * when 'prefers-reduced-motion' is active or when in the Shopify Theme Editor for stability.
 */
class SmoothScroll {
  constructor() {
    if (this.#shouldDisable()) return;
    this.init();
  }

  #shouldDisable() {
    // Disable if the user prefers reduced motion
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    return prefersReducedMotion;
  }

  init() {
    this.lenis = new Lenis({
      duration: 1.5,
      easing: (/** @type {number} */ t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
      direction: 'vertical',
      gestureDirection: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1.2,
      syncTouch: true, 
      touchMultiplier: 1.5,
      infinite: false,
    });

    // Make lenis available globally for other scripts to use
    window.lenis = this.lenis;

    /** @param {number} time */
    const raf = (time) => {
      this.lenis.raf(time);
      requestAnimationFrame(raf);
    };

    requestAnimationFrame(raf);

    // Re-check dimensions on window resize
    window.addEventListener('resize', () => {
      this.lenis.resize();
    });
  }
}

// Instantiate the smooth scroll
new SmoothScroll();
